<template>
  <swiper v-if="banners.length > 0" class="home-banner-swiper" :options="bannerOption" ref="qazlatynBanner">
    <swiper-slide v-for="banner in banners" :key="banner.id">
      <div
        class="banner-content-base">
        <b-link
          :to="linkPrefix + banner.url"
          target="_blank">
          <img class="slide-img swiper-lazy" :src="bigThumnailUrl(host + banner.thumbnailUrl)">
          <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
        </b-link>
        <div class="banner-content">
          <h5 class="banner-title">
            <b-link class="link" :to="linkPrefix + banner.url">
              {{ banner.title }}
            </b-link>
          </h5>
          <p class="ctrl-dir">
            <span class="banner-abouts">
              {{ banner.addTimeMMddyyyyHHmm }}
              <span class="banner-devider">|</span>
              <i class="fas fa-eye"></i> {{ banner.viewCount }}
            </span>
            <span class="float-right banner-control-btns">
              <b-link class="control-btn" @click.prevent="slidePrev()">
                <i class="fas fa-chevron-square-left"></i>
              </b-link>
              <b-link class="control-btn" @click.prevent="slideNext()">
                <i class="fas fa-chevron-square-right"></i>
              </b-link>
            </span>
          </p>
        </div>
      </div>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      bannerOption: {
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        lazy: true,
        observer: true,
        loop: true,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },

  created() {
    this.getBannerList();
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getBannerList();
      }
    }
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    swiper() {
      return this.$refs.qazlatynBanner.swiper;
    },

    linkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    }
  },
  methods: {
    bigThumnailUrl(stringUrl) {
      return stringUrl.replace("_small.", "_big.");
    },

    slideNext() {
      this.swiper.slideNext();
    },

    slidePrev() {
      this.swiper.slidePrev();
    },

    getBannerList() {
      this.$store.state.loading = true;
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("isFocusNews", 1);
      fd.append("pageSize", 5);
      this.$http
        .post(this.host + "/api/qazlatyn/getarticlelist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.banners = result.body.data.dataList;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
          setTimeout(() => this.$store.state.loading = false, 30);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-content-base {
  .slide-img {
    width: 100%;
    height: 100%;
  }

  .banner-content {
    position: absolute;
    background: linear-gradient(#00000000 0%, #00000099 50%, #000000 100%);
    padding: 1.25rem 1rem 0 1rem;
    bottom: 0px;
    left: 0;
    right: 0;

    .banner-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      line-height: 1.5;

      .link {
        color: #f0f0f0;
      }

      &:hover {
        .link {
          text-decoration: underline;
        }
      }
    }

    .banner-abouts {
      color: #dedede;
      font-size: 0.875rem;
      cursor: default;

      .banner-devider {
        display: inline-block;
        margin-right: 1rem;
        margin-left: 1rem;
      }
    }

    .banner-control-btns {
      z-index: 11;

      .control-btn {
        font-size: 1.25rem;
        color: #dedede;
        margin-right: 0.25rem;
        margin-left: 0.25rem;
        cursor: pointer;

        i {
          overflow: hidden;
          border-radius: 50%;
          height: 21px;
          line-height: 22px;
          font-size: 24px;
        }

        &:hover {
          color: #cdcdcd;
        }
      }
    }
  }
}

/* RTL */

.rtl-layout {
  .banner-content {
    .banner-title {
      text-align: right;
      direction: rtl;
    }

    .banner-abouts {
      float: right;
      direction: rtl;
    }

    .banner-control-btns {
      float: left !important;
    }
  }
}
</style>

<style lang="css">
.home-banner-swiper .swiper-pagination-bullet {
  background-color: #ffffff !important;
  opacity: 0.8;
}
.home-banner-swiper .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #007aff !important;
  opacity: 1;
}
.home-banner-swiper .banner-content-base,
.home-banner-swiper .banner-content-base img {
  min-height: 446px !important;
}
.swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
  right: 0;
  width: 200px !important;
  margin: 0 auto;
}
</style>
